const url = process.env.REACT_APP_API_URL + "/api";
export default {
  crrem: {
    list: ({ degree, parameter, projectId }) =>
      `${url}/crrem_data/?parameter=${parameter}&project_id=${projectId}&degree=${degree}`,
  },
  form: {
    post: `${url}/customized_modernization/`,
  },
  goals: {
    list: (projectId) => `${url}/modernization_goals/?project_id=${projectId}`,
  },
  retrofits: {
    get: (id) => `${url}/retrofit/${id}/`,
    list: (projectId) => `${url}/retrofit/?project_id=${projectId}`,
    post: `${url}/retrofit/`,
  },
  scenarioFiles: {
    download: (projectId) => `${url}/modernization/get_whole_zip_files_of_scenario/?project_id=${projectId}`,
  },
  scenarios: {
    list: (projectId) => `${url}/modernization/?project_id=${projectId}`,
  },
  selectedRetrofit: {
    get: (id) => `${url}/chosen_retrofit/${id}/`,
    list: (projectId) => `${url}/chosen_retrofit/?project_id=${projectId}`,
    post: `${url}/chosen_retrofit/`,
  },
};
